import React from "react"
import { Link } from "gatsby"
import {
  CUSTOM_BREAKPOINT_VALUES,
  flexBox,
  MEDIA_BREAKPOINT_KEYS,
  responsiveFontSize,
} from "style/style_snippets"
import { useMediaQuery, useTheme } from "@mui/material"

export const AVAILABLE_ROUTES = {
  HOME: { to: "/", title: "home" },
  PROJECTS: { to: "/projects", title: "projects", partiallyActive: true },
  NEWS: {
    to: "/news",
    title: "news",
    partiallyActive: true,
  } /*Disabled during the COVID-19 pandemic cause there is no meeting taking place*/,
  /*MEET_US:{ to: "/meetUs", title: "meet us", partiallyActive: true },*/
  MANIFESTO: {
    to: "/manifesto",
    title: "manifesto",
    partiallyActive: true,
  },
  TEAM: {
    to: "/team",
    title: "team",
    partiallyActive: true,
  },
  JOBS: {
    to: "/jobs",
    title: "jobs",
    partiallyActive: true
  },
}

const NavBar = () => {
  const theme = useTheme()
  const mediaMatch = useMediaQuery(
    theme.breakpoints.up(MEDIA_BREAKPOINT_KEYS.sm)
  )

  const navBarStyle = {
    container: {
      ...flexBox.row,
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap",
      fontSize: responsiveFontSize(14, 16, CUSTOM_BREAKPOINT_VALUES.sm),
    },
    link: {
      fontWeight: 600,
      textTransform: "capitalize",
      margin: "0 0 0 50px",
      color: "white",
      "&:hover": {
        color: theme.palette.primary.light,
      },
    },
  }

  return (
    mediaMatch && (
      <div css={navBarStyle.container}>
        {Object.values(AVAILABLE_ROUTES).map((route, i) => {
          return (
            <React.Fragment key={i}>
              <Link
                activeStyle={{
                  color: theme.palette.primary.main,
                  fontWeight: 600,
                }}
                partiallyActive={route.partiallyActive}
                css={navBarStyle.link}
                to={route.to}
              >
                <span>{route.title}</span>
              </Link>
            </React.Fragment>
          )
        })}
      </div>
    )
  )
}

export default NavBar
